
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-remove-attribute.html
riot.tag2('menu-item-remove-attribute',
  '<svg class="floating-menu_icon"> <use xlink:href="#delete-icon"></use> </svg> <span class="floating-menu_label">Remove attribute</span>',
  '',
  'class="floating-menu_item" onclick="{removeAttribute}"', function(opts) {
'use strict';

var _this = this;

var _attributesUi = require('lib/node/attributes-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.removeAttribute = function (e) {
  e.preventDefault();
  e.stopPropagation();
  var nodeTag = _this.parent.parentNodeTag;
  if (!nodeTag) return;
  var attributeId = canvas.nodeAttributeTags[nodeTag.id].attributeId;

  var naui = new _attributesUi.NodeAttributesUI({ nodeId: nodeTag.id, canvas: canvas });

  naui.removeAttribute({
    id: _this.parent.attributeId,
    nodeId: nodeTag.id
  });

  _this.parent.hide();

  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Menu-Single-Remove',
    label: 'Attribute-Removed'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-remove-attribute')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-remove-attribute.html
// module id = 704
// module chunks = 0